module.exports = __webpack_public_path__ + "img/gear_ready.2885fb3c.svg";